import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Paragraph, Text} = Typography;


const CommunicationFP = () => {
  return (
    <Layout style={{margin: '50px', background: 'inherit'}}>
      <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-20px'}}>Future Perspectives</Paragraph>
      <Text className='BaseText'>As young people, we have the vision of promoting the communication and choice of STEM careers through our publications, in addition to this we have the desire to continue bringing science to people who are not in these areas, making it easier to understand, as well as entertaining for all kinds of audiences.</Text>
    </Layout>
  );
};

export default CommunicationFP;
